import { Platform } from 'react-native';

export function useGlassAvailable(): boolean {
  if (Platform.OS !== 'ios') return false;

  try {
    const { isLiquidGlassAvailable, isGlassEffectAPIAvailable } =
      // eslint-disable-next-line @typescript-eslint/no-require-imports -- native module must be guarded
      require('expo-glass-effect') as typeof import('expo-glass-effect');
    return isLiquidGlassAvailable() && isGlassEffectAPIAvailable();
  } catch {
    return false;
  }
}
